export default {
  // ============ WAREHOUSE ============
  'warehouse.category': 'Magazyn',
  'warehouse.shortTitle': 'Przewodnik po magazynie USFans',
  'warehouse.readTime': '8 min czytania',
  'warehouse.toc': 'Spis treści',
  'warehouse.h1': 'Magazyn USFans: kompletny przewodnik po przechowywaniu, kontroli i wysyłce',
  'warehouse.lead': 'Dowiedz się, jak działa magazyn USFans, co obejmuje przechowywanie i kontrola oraz jak produkty trafiają z magazynu do Twoich drzwi.',
  'warehouse.s1.title': 'Czym jest magazyn USFans?',
  'warehouse.s1.p1': 'Magazyn USFans to obiekt, w którym zakupione produkty są przyjmowane, przechowywane i przygotowywane do wysyłki. Pełni rolę centralnego punktu przed wysłaniem zamówienia do miejsca docelowego.',
  'warehouse.s1.p2': 'Magazyny pomagają łączyć wiele zakupów od różnych sprzedawców w jedną wysyłkę, co może obniżyć całkowity koszt i wysiłek.',
  'warehouse.s2.title': 'Jak działa przechowywanie',
  'warehouse.s2.p1': 'Gdy produkt trafia do magazynu, jest rejestrowany, etykietowany i umieszczany na półce. Każda paczka jest śledzona, aby można ją było szybko odnaleźć.',
  'warehouse.s2.p2': 'Okresy i zasady przechowywania mogą się różnić, dlatego warto wiedzieć, jak długo produkty mogą pozostać i czy po pewnym czasie obowiązują opłaty.',
  'warehouse.s3.title': 'Kontrola i konsolidacja',
  'warehouse.s3.p1': 'Wiele magazynów oferuje opcjonalną kontrolę, podczas której pracownicy sprawdzają stan produktu lub zawartość paczki przed wysyłką.',
  'warehouse.s3.p2': 'Konsolidacja łączy kilka mniejszych paczek w jedno większe pudełko, co często zmniejsza liczbę przesyłek i może obniżyć koszt wysyłki.',
  'warehouse.s4.title': 'Wysyłka z magazynu',
  'warehouse.s4.p1': 'Gdy produkty są gotowe, magazyn przygotowuje je do wybranej metody wysyłki. Etykiety, dokumenty celne i pakowanie są obsługiwane przed opuszczeniem magazynu.',
  'warehouse.s4.p2': 'Ostateczny czas dostawy zależy od kraju docelowego, przewoźnika i wybranej szybkości wysyłki.',
  'warehouse.s5.title': 'Magazyn a wysyłka bezpośrednia',
  'warehouse.s5.p1': 'Poniższa tabela porównuje korzystanie z magazynu z wysyłką bezpośrednią, aby pokazać główne różnice.',
  'warehouse.table.c1': 'Aspekt',
  'warehouse.table.c2': 'Magazyn',
  'warehouse.table.c3': 'Wysyłka bezpośrednia',
  'warehouse.table.c4': 'Najlepsze do',
  'warehouse.table.r1c1': 'Wiele zamówień',
  'warehouse.table.r1c2': 'Można konsolidować',
  'warehouse.table.r1c3': 'Wysyłane osobno',
  'warehouse.table.r1c4': 'Łączne oszczędności',
  'warehouse.table.r2c1': 'Kontrola',
  'warehouse.table.r2c2': 'Często dostępna',
  'warehouse.table.r2c3': 'Zazwyczaj nie',
  'warehouse.table.r2c4': 'Dodatkowa pewność',
  'warehouse.table.r3c1': 'Czas przechowywania',
  'warehouse.table.r3c2': 'Przechowuje produkty',
  'warehouse.table.r3c3': 'Bez przechowywania',
  'warehouse.table.r3c4': 'Opóźniona wysyłka',
  'warehouse.table.r4c1': 'Złożoność',
  'warehouse.table.r4c2': 'Więcej kroków',
  'warehouse.table.r4c3': 'Mniej kroków',
  'warehouse.table.r4c4': 'Różne potrzeby',
  'warehouse.s6.title': 'Opłaty i czas magazynowania',
  'warehouse.s6.p1': 'Usługi magazynowe mogą wiązać się z opłatami za przechowywanie, konsolidację, kontrolę lub przepakowanie. Opłaty te są różne, dlatego warto sprawdzić aktualny cennik.',
  'warehouse.s6.p2': 'Czas zależy też od szybkości przetwarzania przychodzących paczek i obłożenia magazynu. Planowanie zapasu czasu pomaga uniknąć opóźnień.',
  'warehouse.s7.title': 'Bezpieczeństwo magazynowe',
  'warehouse.s7.p1': 'Korzystaj tylko z zaufanych usług magazynowych i zawsze weryfikuj adres docelowy oraz szczegóły wysyłki przed potwierdzeniem.',
  'warehouse.s7.p2': 'Uważaj na prośby o płatność poza oficjalną platformą i zachowuj numery śledzenia oraz korespondencję.',
  'warehouse.conclusion.title': 'Podsumowanie',
  'warehouse.conclusion.p1': 'Magazyn USFans może ułatwić zakupy wielu produktów dzięki przechowywaniu, kontroli i konsolidacji przed wysyłką.',
  'warehouse.conclusion.p2': 'Zawsze sprawdzaj opłaty, zasady i praktyki bezpieczeństwa, aby korzystać z usług magazynowych pewnie.',
  'warehouse.cta': 'Poznaj pełny sklep',
  'warehouse.backHome': 'Wróć na stronę główną',

  // ============ LEGIT ============
  'legit.category': 'Legalność',
  'legit.shortTitle': 'Czy USFans jest legalny?',
  'legit.readTime': '7 min czytania',
  'legit.toc': 'Spis treści',
  'legit.h1': 'Czy USFans jest legalny? Bezpieczeństwo, zaufanie i co sprawdzić',
  'legit.lead': 'Dowiedz się, jak oceniać legalność USFans, na jakie sygnały zaufania zwracać uwagę i jak się chronić.',
  'legit.s1.title': 'Co oznacza legalność tutaj?',
  'legit.s1.p1': 'Legalność oznacza, czy usługa działa przejrzyście, dotrzymuje obietnic i chroni użytkowników. To kwestia zaufania budowanego w czasie.',
  'legit.s1.p2': 'Żaden niezależny zasób nie powinien twierdzić, że usługa innej firmy jest w pełni bezpieczna. Skup się na weryfikowalnych sygnałach i własnych badaniach.',
  'legit.s2.title': 'Sygnały zaufania',
  'legit.s2.p1': 'Jasne dane kontaktowe, przejrzyste zasady, weryfikowalne dane firmy i responsywne wsparcie to pozytywne znaki dla każdej usługi online.',
  'legit.s2.p2': 'Pomocne są też prawdziwe doświadczenia użytkowników, ale traktuj pojedyncze opinie ostrożnie i szukaj wzorców, a nie pojedynczych ocen.',
  'legit.s3.title': 'Typowe sygnały ostrzegawcze',
  'legit.s3.p1': 'Presja szybkiego działania, prośby o płatność poza oficjalnymi kanałami, niejasne zasady i brak danych kontaktowych to częste znaki ostrzegawcze.',
  'legit.s3.p2': 'Obietnice zbyt piękne, by były prawdziwe, lub prośby o hasła i wrażliwe dane zawsze traktuj ostrożnie.',
  'legit.s4.title': 'Jak weryfikować samodzielnie',
  'legit.s4.p1': 'Sprawdzaj oficjalne źródła bezpośrednio, przeglądaj warunki i potwierdzaj ważne szczegóły, takie jak ceny i wysyłka, zanim się zdecydujesz.',
  'legit.s4.p2': 'Niezależna weryfikacja to najlepsza ochrona, ponieważ informacje zewnętrzne mogą się zmieniać lub dezaktualizować.',
  'legit.s5.title': 'Porównanie czynników zaufania',
  'legit.s5.p1': 'Poniższa tabela podsumowuje kluczowe czynniki przy ocenie, czy usługa wydaje się godna zaufania.',
  'legit.table.c1': 'Czynnik',
  'legit.table.c2': 'Pozytywny znak',
  'legit.table.c3': 'Znak ostrzegawczy',
  'legit.table.c4': 'Co zrobić',
  'legit.table.r1c1': 'Kontakt',
  'legit.table.r1c2': 'Jasny i dostępny',
  'legit.table.r1c3': 'Brak lub niejasny',
  'legit.table.r1c4': 'Zweryfikuj samodzielnie',
  'legit.table.r2c1': 'Zasady',
  'legit.table.r2c2': 'Przejrzyste warunki',
  'legit.table.r2c3': 'Ukryte warunki',
  'legit.table.r2c4': 'Czytaj uważnie',
  'legit.table.r3c1': 'Płatności',
  'legit.table.r3c2': 'Oficjalne kanały',
  'legit.table.r3c3': 'Prośby poza platformą',
  'legit.table.r3c4': 'Unikaj i zgłoś',
  'legit.table.r4c1': 'Wsparcie',
  'legit.table.r4c2': 'Szybka pomoc',
  'legit.table.r4c3': 'Brak odpowiedzi',
  'legit.table.r4c4': 'Przetestuj przed zakupem',
  'legit.s6.title': 'Bezpieczeństwo płatności i konta',
  'legit.s6.p1': 'Płać tylko przez oficjalne, bezpieczne kanały i nigdy nie udostępniaj hasła, kodów weryfikacyjnych ani danych konta.',
  'legit.s6.p2': 'Używaj silnych, unikalnych haseł i włączaj dodatkowe opcje bezpieczeństwa oferowane przez platformę.',
  'legit.s7.title': 'Prywatność',
  'legit.s7.p1': 'Uważaj, jakie informacje osobiste udostępniasz, i unikaj wpisywania wrażliwych danych na nieznanych stronach.',
  'legit.s7.p2': 'Ten niezależny zasób nie wymaga danych osobowych do przeglądania przewodników i artykułów.',
  'legit.conclusion.title': 'Podsumowanie',
  'legit.conclusion.p1': 'Ocena legalności wymaga zrównoważonych, niezależnych badań, a nie opierania się na jednym źródle.',
  'legit.conclusion.p2': 'Zachowaj ostrożność, weryfikuj szczegóły samodzielnie i korzystaj z oficjalnych kanałów.',
  'legit.cta': 'Poznaj pełny sklep',
  'legit.backHome': 'Wróć na stronę główną',

  // ============ CREATOR DIRECTORY ============
  'creator.category': 'Twórcy',
  'creator.shortTitle': 'Przewodnik po katalogu twórców USFans',
  'creator.readTime': '7 min czytania',
  'creator.toc': 'Spis treści',
  'creator.h1': 'Katalog twórców USFans: jak znajdować i przeglądać twórców',
  'creator.lead': 'Dowiedz się, jak działają katalogi twórców, jak znajdować konkretnych twórców i efektywnie przeglądać profile.',
  'creator.s1.title': 'Czym jest katalog twórców?',
  'creator.s1.p1': 'Katalog twórców to uporządkowana lista twórców, zwykle posegregowana według kategorii, nazwy lub statusu, aby ułatwić odkrywanie.',
  'creator.s1.p2': 'Katalogi pozwalają przeglądać wiele profili w jednym miejscu zamiast szukać strona po stronie, co oszczędza czas.',
  'creator.s2.title': 'Jak przeglądać katalog',
  'creator.s2.p1': 'Zacznij od interesującej Cię kategorii, a następnie przeglądaj poszczególne wpisy, aby zrozumieć, co oferuje każdy twórca.',
  'creator.s2.p2': 'Filtry i wyszukiwanie mogą zawęzić wyniki według nazwy lub tematu, pomagając skupić się na najtrafniejszych profilach.',
  'creator.s3.title': 'Czytanie profilu twórcy',
  'creator.s3.p1': 'Profil zwykle zawiera nazwę twórcy, kategorię, link lub odnośnik, status i datę ostatniej aktualizacji.',
  'creator.s3.p2': 'Skup się na aktywnych i niedawno zaktualizowanych wpisach i weryfikuj ważne szczegóły bezpośrednio.',
  'creator.s4.title': 'Wskazówki odkrywania',
  'creator.s4.p1': 'Zacznij szeroko, a potem zawężaj. Najpierw przeglądaj kategorię, a następnie szukaj twórców pasujących do Twoich zainteresowań.',
  'creator.s4.p2': 'Robienie notatek podczas przeglądania pomaga porównywać twórców i wracać do najciekawszych.',
  'creator.s5.title': 'Katalog a arkusz',
  'creator.s5.p1': 'Poniższa tabela porównuje katalog twórców z widokiem arkusza, aby wyjaśnić, kiedy który jest bardziej przydatny.',
  'creator.table.c1': 'Aspekt',
  'creator.table.c2': 'Katalog',
  'creator.table.c3': 'Arkusz',
  'creator.table.c4': 'Najlepsze do',
  'creator.table.r1c1': 'Układ',
  'creator.table.r1c2': 'Strony kategorii',
  'creator.table.r1c3': 'Wiersze i kolumny',
  'creator.table.r1c4': 'Różne przeglądanie',
  'creator.table.r2c1': 'Odkrywanie',
  'creator.table.r2c2': 'Według tematu',
  'creator.table.r2c3': 'Skanowanie i porównanie',
  'creator.table.r2c4': 'Oba przydatne',
  'creator.table.r3c1': 'Aktualizacja',
  'creator.table.r3c2': 'Zależy od utrzymania',
  'creator.table.r3c3': 'Zależy od utrzymania',
  'creator.table.r3c4': 'Weryfikuj ręcznie',
  'creator.table.r4c1': 'Krzywa uczenia',
  'creator.table.r4c2': 'Bardzo niska',
  'creator.table.r4c3': 'Niska',
  'creator.table.r4c4': 'Łatwy start',
  'creator.s6.title': 'Jakość danych i weryfikacja',
  'creator.s6.p1': 'Katalogi tworzone przez społeczność mogą zawierać nieaktualne lub niekompletne wpisy, dlatego zawsze weryfikuj linki i szczegóły samodzielnie.',
  'creator.s6.p2': 'Traktuj ostrożnie linki proszące o dane osobowe lub płatność i trzymaj się zaufanych, oficjalnych źródeł.',
  'creator.s7.title': 'Prywatność podczas przeglądania',
  'creator.s7.p1': 'Unikaj udostępniania wrażliwych danych na nieznanych stronach i korzystaj z oficjalnych witryn przy koncie i zakupach.',
  'creator.s7.p2': 'Ten niezależny zasób pozwala przeglądać przewodniki i katalogi bez podawania danych osobowych.',
  'creator.conclusion.title': 'Podsumowanie',
  'creator.conclusion.p1': 'Katalog twórców to wygodny punkt wyjścia do odkrywania i porównywania twórców w jednym miejscu.',
  'creator.conclusion.p2': 'Połącz przeglądanie katalogu z niezależną weryfikacją, aby uzyskać najdokładniejszy obraz.',
  'creator.cta': 'Poznaj pełny sklep',
  'creator.backHome': 'Wróć na stronę główną',

  // ============ SPREADSHEET SEARCH ============
  'search.category': 'Wyszukiwanie',
  'search.shortTitle': 'Przewodnik po wyszukiwaniu w arkuszu USFans',
  'search.readTime': '6 min czytania',
  'search.toc': 'Spis treści',
  'search.h1': 'Wyszukiwanie w arkuszu USFans: jak szybko znaleźć to, czego potrzebujesz',
  'search.lead': 'Poznaj praktyczne wskazówki wyszukiwania w arkuszu USFans, korzystania z filtrów i szybkiego zawężania wyników.',
  'search.s1.title': 'Dlaczego wyszukiwanie ma znaczenie',
  'search.s1.p1': 'Dobrze zorganizowany arkusz może zawierać wiele wpisów, więc umiejętne wyszukiwanie pomaga znaleźć to, czego potrzebujesz, bez przeglądania wszystkiego.',
  'search.s1.p2': 'Dobre nawyki wyszukiwania zamieniają duży zasób w szybkie, skoncentrowane narzędzie.',
  'search.s2.title': 'Zaczynanie od kategorii',
  'search.s2.p1': 'Zacznij od wyboru kategorii najlepiej pasującej do tego, czego szukasz, a potem przeglądaj wpisy w jej obrębie.',
  'search.s2.p2': 'Ten prosty pierwszy krok usuwa większość nieistotnych wyników, zanim zaczniesz czytać poszczególne wpisy.',
  'search.s3.title': 'Korzystanie z filtrów i słów kluczowych',
  'search.s3.p1': 'Używaj filtrów do zawężania według nazwy, statusu lub daty aktualizacji oraz krótkich, konkretnych słów kluczowych zamiast długich fraz.',
  'search.s3.p2': 'Jeśli słowo kluczowe jest zbyt wąskie i nic nie zwraca, spróbuj szerszego terminu, a potem stopniowo zawężaj.',
  'search.s4.title': 'Czytanie wyników',
  'search.s4.p1': 'Zwracaj uwagę na status i informacje o aktualizacji, aby priorytetowo traktować aktywne, niedawno zaktualizowane wpisy.',
  'search.s4.p2': 'Otwieraj obiecujące wyniki w nowej karcie, aby porównać kilka wpisów bez gubienia miejsca.',
  'search.s5.title': 'Porównanie podejść do wyszukiwania',
  'search.s5.p1': 'Poniższa tabela porównuje typowe podejścia do wyszukiwania, aby pomóc wybrać właściwe.',
  'search.table.c1': 'Podejście',
  'search.table.c2': 'Jak działa',
  'search.table.c3': 'Zaleta',
  'search.table.c4': 'Użyj, gdy',
  'search.table.r1c1': 'Według kategorii',
  'search.table.r1c2': 'Przeglądaj grupę',
  'search.table.r1c3': 'Szerokie odkrywanie',
  'search.table.r1c4': 'Eksploracja tematów',
  'search.table.r2c1': 'Według słowa kluczowego',
  'search.table.r2c2': 'Dopasuj termin',
  'search.table.r2c3': 'Szybkie zawężanie',
  'search.table.r2c4': 'Znane nazwy',
  'search.table.r3c1': 'Według statusu',
  'search.table.r3c2': 'Filtruj aktywne',
  'search.table.r3c3': 'Świeże wyniki',
  'search.table.r3c4': 'Priorytet aktualizacji',
  'search.table.r4c1': 'Według daty',
  'search.table.r4c2': 'Sortuj po aktualizacji',
  'search.table.r4c3': 'Tylko najnowsze',
  'search.table.r4c4': 'Sprawdzanie aktualności',
  'search.s6.title': 'Typowe błędy wyszukiwania',
  'search.s6.p1': 'Zbyt konkretne słowa kluczowe, ignorowanie filtrów i pomijanie informacji o statusie to częste błędy spowalniające wyszukiwanie.',
  'search.s6.p2': 'Zacznij szeroko, stosuj filtry stopniowo i zawsze sprawdzaj datę aktualizacji przed poleganiem na wpisie.',
  'search.s7.title': 'Bezpieczeństwo wyszukiwania',
  'search.s7.p1': 'Uważaj na wyniki przekierowujące na nieznane strony i nigdy nie podawaj danych osobowych ani płatności na niezaufanych witrynach.',
  'search.s7.p2': 'Trzymaj się znanych, oficjalnych źródeł i weryfikuj ważne szczegóły samodzielnie.',
  'search.conclusion.title': 'Podsumowanie',
  'search.conclusion.p1': 'Skuteczne wyszukiwanie zamienia arkusz USFans z długiej listy w szybki, skoncentrowany zasób.',
  'search.conclusion.p2': 'Używaj kategorii, filtrów i informacji o statusie razem, aby znaleźć to, czego potrzebujesz, szybko i bezpiecznie.',
  'search.cta': 'Poznaj pełny sklep',
  'search.backHome': 'Wróć na stronę główną',

  // ============ SAFETY ============
  'safety.category': 'Bezpieczeństwo',
  'safety.shortTitle': 'Centrum bezpieczeństwa USFans',
  'safety.readTime': '8 min czytania',
  'safety.toc': 'Spis treści',
  'safety.h1': 'Centrum bezpieczeństwa USFans: chroń konto i płatności',
  'safety.lead': 'Praktyczne wskazówki dotyczące bezpieczeństwa konta, płatności, ochrony przed phishingiem i prywatności.',
  'safety.s1.title': 'Dlaczego bezpieczeństwo ma znaczenie',
  'safety.s1.p1': 'Usługi online wiążą się z danymi osobowymi i płatnościami, więc podstawowe nawyki bezpieczeństwa chronią konto i pieniądze.',
  'safety.s1.p2': 'Większości problemów można uniknąć dzięki kilku prostym, konsekwentnym środkom ostrożności.',
  'safety.s2.title': 'Podstawy bezpieczeństwa konta',
  'safety.s2.p1': 'Używaj silnego, unikalnego hasła do każdej usługi i nigdy nie używaj tego samego hasła na różnych platformach.',
  'safety.s2.p2': 'Włączaj dodatkowe opcje bezpieczeństwa oferowane przez platformę i utrzymuj aktualne dane odzyskiwania.',
  'safety.s3.title': 'Bezpieczeństwo płatności',
  'safety.s3.p1': 'Płać tylko przez oficjalne, bezpieczne kanały i zawsze potwierdzaj szczegóły przed sfinalizowaniem transakcji.',
  'safety.s3.p2': 'Nigdy nie udostępniaj danych płatności, kodów weryfikacyjnych ani haseł osobom, które kontaktują się niespodziewanie.',
  'safety.s4.title': 'Świadomość phishingu i oszustw',
  'safety.s4.p1': 'Wiadomości phishingowe często imitują prawdziwą usługę i wywierają presję szybkiego działania lub kliknięcia linku. Weryfikuj nadawcę przed odpowiedzią.',
  'safety.s4.p2': 'Uważaj na oferty zbyt piękne, by były prawdziwe, oraz na prośby o przeniesienie rozmowy lub płatności do nieoficjalnych kanałów.',
  'safety.s5.title': 'Ryzyko a ochrona',
  'safety.s5.p1': 'Poniższa tabela zestawia typowe ryzyka z prostymi zabezpieczeniami.',
  'safety.table.c1': 'Ryzyko',
  'safety.table.c2': 'Przykład',
  'safety.table.c3': 'Ochrona',
  'safety.table.c4': 'Priorytet',
  'safety.table.r1c1': 'Przejęcie konta',
  'safety.table.r1c2': 'Słabe hasło',
  'safety.table.r1c3': 'Unikalne hasło',
  'safety.table.r1c4': 'Wysoki',
  'safety.table.r2c1': 'Oszustwo płatnicze',
  'safety.table.r2c2': 'Prośba poza platformą',
  'safety.table.r2c3': 'Oficjalne kanały',
  'safety.table.r2c4': 'Wysoki',
  'safety.table.r3c1': 'Phishing',
  'safety.table.r3c2': 'Fałszywa wiadomość',
  'safety.table.r3c3': 'Weryfikuj nadawcę',
  'safety.table.r3c4': 'Wysoki',
  'safety.table.r4c1': 'Ujawnienie danych',
  'safety.table.r4c2': 'Nadmierne udostępnianie',
  'safety.table.r4c3': 'Ogranicz udostępnianie',
  'safety.table.r4c4': 'Średni',
  'safety.s6.title': 'Weryfikacja danych',
  'safety.s6.p1': 'Zawsze weryfikuj linki, ceny i zasady bezpośrednio na oficjalnej stronie przed podjęciem decyzji lub płatnością.',
  'safety.s6.p2': 'Informacje zewnętrzne mogą się zmieniać lub dezaktualizować, więc niezależna weryfikacja jest niezbędna.',
  'safety.s7.title': 'Ochrona prywatności',
  'safety.s7.p1': 'Uważaj, co udostępniasz online, i unikaj wpisywania wrażliwych danych na nieznanych stronach.',
  'safety.s7.p2': 'Ten niezależny zasób nie prosi o dane osobowe do przeglądania treści.',
  'safety.conclusion.title': 'Podsumowanie',
  'safety.conclusion.p1': 'Kilka konsekwentnych nawyków bezpieczeństwa skutecznie chroni konto, płatności i prywatność.',
  'safety.conclusion.p2': 'Bądź ostrożny, weryfikuj samodzielnie i korzystaj z oficjalnych kanałów przy wrażliwych czynnościach.',
  'safety.cta': 'Poznaj pełny sklep',
  'safety.backHome': 'Wróć na stronę główną',

  // ============ FAQ ============
  'faq.category': 'FAQ',
  'faq.shortTitle': 'Kompletne FAQ USFans',
  'faq.readTime': '6 min czytania',
  'faq.toc': 'Spis treści',
  'faq.h1': 'FAQ USFans: odpowiedzi na częste pytania',
  'faq.lead': 'Jasne odpowiedzi na najczęstsze pytania o USFans, arkusz, wysyłkę, kupony i bezpieczeństwo.',
  'faq.s1.title': 'Pierwsze kroki',
  'faq.s1.p1': 'Jeśli dopiero zaczynasz z USFans, najpierw zrozum, czym jest i jak zorganizowane są jego zasoby.',
  'faq.s1.p2': 'Przewodniki na tej stronie prowadzą przez podstawy krok po kroku, aby szybko zbudować jasny obraz.',
  'faq.s2.title': 'O arkuszu',
  'faq.s2.p1': 'Arkusz USFans to zorganizowany zasób, który zbiera listy twórców, kategorie i przydatne linki w jednym miejscu.',
  'faq.s2.p2': 'Jest zaprojektowany tak, aby odkrywanie i porównywanie było łatwiejsze niż przeszukiwanie wielu osobnych stron.',
  'faq.s3.title': 'O wysyłce',
  'faq.s3.p1': 'Koszty wysyłki zależą od takich czynników jak miejsce docelowe, waga, przewoźnik i szybkość, i mogą się zmieniać.',
  'faq.s3.p2': 'Zawsze potwierdzaj aktualne szczegóły wysyłki bezpośrednio na oficjalnej stronie przed złożeniem zamówienia.',
  'faq.s4.title': 'O kuponach i zniżkach',
  'faq.s4.p1': 'Kupony i kody rabatowe mogą się zmieniać lub wygasać, dlatego najlepiej sprawdzać aktualne oferty w oficjalnym sklepie.',
  'faq.s4.p2': 'Używaj tylko kodów z zaufanych źródeł i unikaj tych, które wydają się podejrzane lub zbyt dobre.',
  'faq.s5.title': 'Porównanie częstych pytań',
  'faq.s5.p1': 'Poniższa tabela podsumowuje kilka częstych pytań i ich krótkie odpowiedzi.',
  'faq.table.c1': 'Pytanie',
  'faq.table.c2': 'Krótka odpowiedź',
  'faq.table.c3': 'Powiązany przewodnik',
  'faq.table.c4': 'Gdzie weryfikować',
  'faq.table.r1c1': 'Czym jest USFans?',
  'faq.table.r1c2': 'Zasób zakupowy',
  'faq.table.r1c3': 'Przewodnik dla początkujących',
  'faq.table.r1c4': 'Oficjalna strona',
  'faq.table.r2c1': 'Jak liczy się wysyłka?',
  'faq.table.r2c2': 'Kilka czynników',
  'faq.table.r2c3': 'Przewodnik wysyłki',
  'faq.table.r2c4': 'Oficjalna strona',
  'faq.table.r3c1': 'Czy kupony są prawdziwe?',
  'faq.table.r3c2': 'Zależy od oferty',
  'faq.table.r3c3': 'Przewodnik kuponów',
  'faq.table.r3c4': 'Oficjalny sklep',
  'faq.table.r4c1': 'Czy to bezpieczne?',
  'faq.table.r4c2': 'Zachowaj ostrożność',
  'faq.table.r4c3': 'Centrum bezpieczeństwa',
  'faq.table.r4c4': 'Niezależna weryfikacja',
  'faq.s6.title': 'Rozwiązywanie problemów',
  'faq.s6.p1': 'Jeśli link nie działa lub informacje są nieaktualne, sprawdź oficjalną stronę i poszukaj najnowszych szczegółów.',
  'faq.s6.p2': 'W sprawie konta lub płatności kontaktuj się z oficjalnym wsparciem wyłącznie przez zweryfikowane kanały.',
  'faq.s7.title': 'Więcej pomocy',
  'faq.s7.p1': 'Przeglądaj powiązane przewodniki na tej stronie, aby uzyskać głębsze wyjaśnienia każdego tematu.',
  'faq.s7.p2': 'Pamiętaj, że to niezależny zasób, więc zawsze sam potwierdzaj ważne szczegóły.',
  'faq.conclusion.title': 'Podsumowanie',
  'faq.conclusion.p1': 'Większość pytań ma prostą odpowiedź, gdy wiesz, gdzie szukać.',
  'faq.conclusion.p2': 'Korzystaj z przewodników i oficjalnych źródeł razem, aby uzyskać dokładne, aktualne informacje.',
  'faq.cta': 'Poznaj pełny sklep',
  'faq.backHome': 'Wróć na stronę główną',

  // ============ ALTERNATIVES ============
  'alternatives.category': 'Alternatywy',
  'alternatives.shortTitle': 'Alternatywy USFans',
  'alternatives.readTime': '7 min czytania',
  'alternatives.toc': 'Spis treści',
  'alternatives.h1': 'Alternatywy USFans: jak porównać opcje',
  'alternatives.lead': 'Dowiedz się, jak oceniać alternatywy dla USFans i porównywać usługi pod kątem swoich potrzeb.',
  'alternatives.s1.title': 'Dlaczego warto rozważyć alternatywy',
  'alternatives.s1.p1': 'Różne usługi oferują różne funkcje, ceny i opcje wysyłki, więc porównanie alternatyw może pomóc znaleźć najlepsze dopasowanie.',
  'alternatives.s1.p2': 'Zrozumienie, co jest dla Ciebie najważniejsze, sprawia, że porównanie jest bardziej przydatne i skoncentrowane.',
  'alternatives.s2.title': 'Co porównywać',
  'alternatives.s2.p1': 'Skup się na czynnikach, które mają na Ciebie największy wpływ: koszcie wysyłki, czasie dostawy, dostępnych kategoriach i łatwości użycia.',
  'alternatives.s2.p2': 'Ważne są też zasady, jakość wsparcia i przejrzystość, które wiele mówią o usłudze.',
  'alternatives.s3.title': 'Wysyłka i ceny',
  'alternatives.s3.p1': 'Porównuj metody wysyłki, szacowany czas dostawy i dodatkowe opłaty, ponieważ bezpośrednio wpływają na koszt końcowy.',
  'alternatives.s3.p2': 'Ceny mogą się zmieniać, więc potwierdzaj aktualne stawki bezpośrednio, zamiast polegać tylko na starszych porównaniach.',
  'alternatives.s4.title': 'Zaufanie i wsparcie',
  'alternatives.s4.p1': 'Szukaj jasnych danych kontaktowych, przejrzystych zasad i responsywnego wsparcia przy ocenie alternatyw.',
  'alternatives.s4.p2': 'Pomocne mogą być niezależne recenzje i dyskusje społeczności, ale zawsze weryfikuj ważne twierdzenia samodzielnie.',
  'alternatives.s5.title': 'Ramy porównania',
  'alternatives.s5.p1': 'Poniższa tabela oferuje prosty schemat porównywania usług obok siebie.',
  'alternatives.table.c1': 'Czynnik',
  'alternatives.table.c2': 'Co sprawdzić',
  'alternatives.table.c3': 'Dlaczego ważne',
  'alternatives.table.c4': 'Jak weryfikować',
  'alternatives.table.r1c1': 'Wysyłka',
  'alternatives.table.r1c2': 'Koszt i szybkość',
  'alternatives.table.r1c3': 'Wpływa na cenę',
  'alternatives.table.r1c4': 'Oficjalne stawki',
  'alternatives.table.r2c1': 'Kategorie',
  'alternatives.table.r2c2': 'Dostępne produkty',
  'alternatives.table.r2c3': 'Pasuje do potrzeb',
  'alternatives.table.r2c4': 'Przeglądaj sklep',
  'alternatives.table.r3c1': 'Zasady',
  'alternatives.table.r3c2': 'Warunki i opłaty',
  'alternatives.table.r3c3': 'Unikaj niespodzianek',
  'alternatives.table.r3c4': 'Czytaj warunki',
  'alternatives.table.r4c1': 'Wsparcie',
  'alternatives.table.r4c2': 'Responsywność',
  'alternatives.table.r4c3': 'Spokój ducha',
  'alternatives.table.r4c4': 'Przetestuj kontakt',
  'alternatives.s6.title': 'Unikanie stronniczości',
  'alternatives.s6.p1': 'Każda usługa ma mocne i słabe strony, więc staraj się je ważyć obiektywnie, zamiast polegać na jednej mocnej opinii.',
  'alternatives.s6.p2': 'Szukaj wzorców w wielu źródłach i weryfikuj fakty bezpośrednio przed wyciąganiem wniosków.',
  'alternatives.s7.title': 'Zachowanie bezpieczeństwa',
  'alternatives.s7.p1': 'Stosuj te same nawyki bezpieczeństwa do każdej usługi: używaj oficjalnych kanałów, weryfikuj szczegóły i chroń konto oraz płatności.',
  'alternatives.s7.p2': 'Bądź szczególnie ostrożny wobec alternatyw, o których wcześniej nie słyszałeś.',
  'alternatives.conclusion.title': 'Podsumowanie',
  'alternatives.conclusion.p1': 'Przemyślane porównanie alternatyw pomaga wybrać usługę najlepiej dopasowaną do Twoich potrzeb.',
  'alternatives.conclusion.p2': 'Skup się na najważniejszych czynnikach i zawsze weryfikuj aktualne informacje samodzielnie.',
  'alternatives.cta': 'Poznaj pełny sklep',
  'alternatives.backHome': 'Wróć na stronę główną',

  // ============ SHIPPING OPTIONS ============
  'shippingopts.category': 'Wysyłka',
  'shippingopts.shortTitle': 'Przewodnik po opcjach wysyłki USFans',
  'shippingopts.readTime': '7 min czytania',
  'shippingopts.toc': 'Spis treści',
  'shippingopts.h1': 'Opcje wysyłki USFans: metody, dostawa i wysyłka międzynarodowa',
  'shippingopts.lead': 'Dowiedz się o różnych opcjach wysyłki, jak różnią się czasy dostawy i co warto wiedzieć o wysyłce międzynarodowej.',
  'shippingopts.s1.title': 'Zrozumienie opcji wysyłki',
  'shippingopts.s1.p1': 'Opcje wysyłki różnią się szybkością, przewoźnikiem i kosztem, a właściwy wybór zależy od tego, jak szybko potrzebujesz zamówienia.',
  'shippingopts.s1.p2': 'Szybsze metody zwykle kosztują więcej, a wolniejsze mogą oszczędzić pieniądze, jeśli się nie spieszysz.',
  'shippingopts.s2.title': 'Czasy dostawy',
  'shippingopts.s2.p1': 'Czas dostawy zależy od miejsca docelowego, przewoźnika i wybranej szybkości, a szacunki mogą się różnić.',
  'shippingopts.s2.p2': 'Zawsze sprawdzaj aktualne szacowane czasy dostawy na oficjalnej stronie przed złożeniem zamówienia.',
  'shippingopts.s3.title': 'Wysyłka międzynarodowa',
  'shippingopts.s3.p1': 'Zamówienia międzynarodowe mogą wiązać się z cłem, opłatami i dodatkową obsługą, co wpływa na koszt i czas dostawy.',
  'shippingopts.s3.p2': 'Poznaj przepisy kraju docelowego i potencjalne opłaty, aby uniknąć niespodzianek.',
  'shippingopts.s4.title': 'Wybór właściwej metody',
  'shippingopts.s4.p1': 'Równoważ koszt, szybkość i śledzenie przy wyborze metody oraz rozważ konsolidację przy wielu produktach.',
  'shippingopts.s4.p2': 'Numery śledzenia pomagają monitorować zamówienie i szybko zauważyć opóźnienia lub problemy.',
  'shippingopts.s5.title': 'Porównanie metod wysyłki',
  'shippingopts.s5.p1': 'Poniższa tabela porównuje typowe rodzaje metod wysyłki i kiedy każda jest dobrym wyborem.',
  'shippingopts.table.c1': 'Metoda',
  'shippingopts.table.c2': 'Szybkość',
  'shippingopts.table.c3': 'Koszt',
  'shippingopts.table.c4': 'Najlepsze do',
  'shippingopts.table.r1c1': 'Standardowa',
  'shippingopts.table.r1c2': 'Wolniejsza',
  'shippingopts.table.r1c3': 'Niższy',
  'shippingopts.table.r1c4': 'Oszczędzanie',
  'shippingopts.table.r2c1': 'Ekspresowa',
  'shippingopts.table.r2c2': 'Szybsza',
  'shippingopts.table.r2c3': 'Wyższy',
  'shippingopts.table.r2c4': 'Pilne zamówienia',
  'shippingopts.table.r3c1': 'Śledzona',
  'shippingopts.table.r3c2': 'Różna',
  'shippingopts.table.r3c3': 'Umiarkowany',
  'shippingopts.table.r3c4': 'Spokój ducha',
  'shippingopts.table.r4c1': 'Konsolidowana',
  'shippingopts.table.r4c2': 'Zależy',
  'shippingopts.table.r4c3': 'Może być niższy',
  'shippingopts.table.r4c4': 'Wiele produktów',
  'shippingopts.s6.title': 'Śledzenie zamówienia',
  'shippingopts.s6.p1': 'Użyj numeru śledzenia, aby monitorować postęp, i kontaktuj się ze wsparciem przez oficjalne kanały w razie opóźnienia.',
  'shippingopts.s6.p2': 'Zachowuj numery śledzenia i korespondencję na wypadek konieczności kontaktu.',
  'shippingopts.s7.title': 'Bezpieczeństwo wysyłki',
  'shippingopts.s7.p1': 'Podawaj dane wysyłki tylko na zaufanych, oficjalnych platformach i dokładnie weryfikuj adres docelowy.',
  'shippingopts.s7.p2': 'Uważaj na prośby o zmianę miejsca docelowego poza oficjalnym procesem.',
  'shippingopts.conclusion.title': 'Podsumowanie',
  'shippingopts.conclusion.p1': 'Zrozumienie opcji wysyłki pomaga zrównoważyć koszt, szybkość i niezawodność.',
  'shippingopts.conclusion.p2': 'Zawsze potwierdzaj aktualne stawki i czasy dostawy na oficjalnej stronie przed zamówieniem.',
  'shippingopts.cta': 'Poznaj pełny sklep',
  'shippingopts.backHome': 'Wróć na stronę główną',

  // ============ DISCOUNT CODE ============
  'discount.category': 'Zniżki',
  'discount.shortTitle': 'Przewodnik po kodach rabatowych USFans',
  'discount.readTime': '6 min czytania',
  'discount.toc': 'Spis treści',
  'discount.h1': 'Przewodnik po kodach rabatowych i promocyjnych USFans',
  'discount.lead': 'Dowiedz się, jak działają kody rabatowe i promocyjne, gdzie je znaleźć i jak unikać wygasłych lub podejrzanych ofert.',
  'discount.s1.title': 'Jak działają kody rabatowe',
  'discount.s1.p1': 'Kod rabatowy to krótki tekst, który wpisujesz przy kasie, aby zastosować zniżkę, promocję lub ofertę specjalną.',
  'discount.s1.p2': 'Kody mogą dotyczyć konkretnych produktów, minimalnej wartości zamówienia lub okresów, więc ich warunki się różnią.',
  'discount.s2.title': 'Gdzie szukać kodów',
  'discount.s2.p1': 'Oficjalne kanały, takie jak sam sklep lub jego zweryfikowane strony, to najbardziej niezawodne miejsca z aktualnymi ofertami.',
  'discount.s2.p2': 'Zawsze potwierdzaj, że kod jest ważny i aktualny, zanim na nim polegasz, ponieważ oferty często się zmieniają.',
  'discount.s3.title': 'Rodzaje zniżek',
  'discount.s3.p1': 'Typowe rodzaje to zniżki procentowe, zniżki o stałą kwotę oraz promocje z darmową wysyłką lub zestawami.',
  'discount.s3.p2': 'Zrozumienie rodzaju pomaga oszacować rzeczywiste oszczędności i uczciwie porównywać oferty.',
  'discount.s4.title': 'Unikanie wygasłych lub fałszywych kodów',
  'discount.s4.p1': 'Kody mogą wygasać lub przestawać działać, więc testuj je przy kasie i unikaj podejrzanych.',
  'discount.s4.p2': 'Uważaj na oferty zbyt piękne, by były prawdziwe, lub proszące o odwiedzenie nieoficjalnych stron.',
  'discount.s5.title': 'Porównanie rodzajów zniżek',
  'discount.s5.p1': 'Poniższa tabela podsumowuje typowe rodzaje zniżek i co sprawdzić przy każdym.',
  'discount.table.c1': 'Rodzaj',
  'discount.table.c2': 'Jak działa',
  'discount.table.c3': 'Najlepsze do',
  'discount.table.c4': 'Co sprawdzić',
  'discount.table.r1c1': 'Procentowa',
  'discount.table.r1c2': 'Obniża o procent',
  'discount.table.r1c3': 'Większe zamówienia',
  'discount.table.r1c4': 'Minimalna kwota',
  'discount.table.r2c1': 'Stała kwota',
  'discount.table.r2c2': 'Obniża o wartość',
  'discount.table.r2c3': 'Każde zamówienie',
  'discount.table.r2c4': 'Warunki i ważność',
  'discount.table.r3c1': 'Darmowa wysyłka',
  'discount.table.r3c2': 'Zwalnia z opłaty',
  'discount.table.r3c3': 'Oszczędność na dostawie',
  'discount.table.r3c4': 'Warunki',
  'discount.table.r4c1': 'Zestaw',
  'discount.table.r4c2': 'Zniżka na zestaw',
  'discount.table.r4c3': 'Wiele produktów',
  'discount.table.r4c4': 'Objęte produkty',
  'discount.s6.title': 'Maksymalizacja oszczędności',
  'discount.s6.p1': 'Porównaj kilka aktywnych ofert, sprawdź warunki i łącz zniżki tylko tam, gdzie sklep na to pozwala.',
  'discount.s6.p2': 'Obserwuj oficjalne ogłoszenia, aby złapać promocje, póki są ważne.',
  'discount.s7.title': 'Bezpieczne korzystanie z kodów',
  'discount.s7.p1': 'Stosuj kody tylko przy oficjalnej kasie i nigdy nie udostępniaj danych płatności na nieoficjalnych stronach.',
  'discount.s7.p2': 'Jeśli kod prosi o dane osobowe lub przekierowuje gdzie indziej, zamknij stronę i użyj oficjalnego sklepu.',
  'discount.conclusion.title': 'Podsumowanie',
  'discount.conclusion.p1': 'Kody rabatowe i promocyjne mogą obniżyć koszt, gdy rozumiesz ich warunki i używasz ich bezpiecznie.',
  'discount.conclusion.p2': 'Trzymaj się oficjalnych źródeł i weryfikuj aktualne oferty przed kasą.',
  'discount.cta': 'Poznaj pełny sklep',
  'discount.backHome': 'Wróć na stronę główną',

  // ============ BEGINNER GUIDE ============
  'beginner.category': 'Początkujący',
  'beginner.shortTitle': 'Przewodnik dla początkujących USFans',
  'beginner.readTime': '8 min czytania',
  'beginner.toc': 'Spis treści',
  'beginner.h1': 'Przewodnik dla początkujących USFans: krok po kroku',
  'beginner.lead': 'Przyjazne wprowadzenie do USFans, obejmujące podstawy, działanie zasobów i bezpieczny start.',
  'beginner.s1.title': 'Witamy w USFans',
  'beginner.s1.p1': 'USFans to zasób zakupowy, z którego wiele osób korzysta, aby poznawać produkty, kategorie i twórców w jednym miejscu.',
  'beginner.s1.p2': 'Ten przewodnik prowadzi przez podstawy, abyś mógł zacząć odkrywać z pewnością.',
  'beginner.s2.title': 'Zrozumienie podstaw',
  'beginner.s2.p1': 'Przed przeglądaniem poświęć chwilę, aby zrozumieć, jak zorganizowane są główne zasoby, takie jak arkusz i katalogi.',
  'beginner.s2.p2': 'Jasny przegląd ułatwia wszystko inne: od wyszukiwania, przez porównywanie, po kasę.',
  'beginner.s3.title': 'Odkrywanie kategorii',
  'beginner.s3.p1': 'Zacznij od interesującej kategorii, a następnie odkrywaj produkty i twórców w jej obrębie we własnym tempie.',
  'beginner.s3.p2': 'Na tej stronie lista kategorii i przyciski prowadzą bezpośrednio do odpowiadających sekcji głównego sklepu.',
  'beginner.s4.title': 'Podejmowanie pierwszej decyzji',
  'beginner.s4.p1': 'Porównaj kilka opcji, sprawdź szczegóły wysyłki i przeczytaj odpowiednie przewodniki przed pierwszym wyborem.',
  'beginner.s4.p2': 'Nie ma pośpiechu — poświęcenie czasu na zrozumienie opcji prowadzi do lepszych decyzji.',
  'beginner.s5.title': 'Porównanie pierwszych kroków',
  'beginner.s5.p1': 'Poniższa tabela mapuje typowe pierwsze kroki na zasoby, które pomagają przy każdym z nich.',
  'beginner.table.c1': 'Krok',
  'beginner.table.c2': 'Co zrobić',
  'beginner.table.c3': 'Pomocny przewodnik',
  'beginner.table.c4': 'Kluczowa wskazówka',
  'beginner.table.r1c1': 'Poznaj podstawy',
  'beginner.table.r1c2': 'Przeczytaj wstęp',
  'beginner.table.r1c3': 'Ten przewodnik',
  'beginner.table.r1c4': 'Bez pośpiechu',
  'beginner.table.r2c1': 'Przeglądaj kategorie',
  'beginner.table.r2c2': 'Wybierz kategorię',
  'beginner.table.r2c3': 'Lista kategorii',
  'beginner.table.r2c4': 'Zacznij szeroko',
  'beginner.table.r3c1': 'Porównaj opcje',
  'beginner.table.r3c2': 'Przeglądaj produkty',
  'beginner.table.r3c3': 'Tabele porównawcze',
  'beginner.table.r3c4': 'Zapisuj różnice',
  'beginner.table.r4c1': 'Sprawdź wysyłkę',
  'beginner.table.r4c2': 'Potwierdź koszty',
  'beginner.table.r4c3': 'Przewodnik wysyłki',
  'beginner.table.r4c4': 'Weryfikuj oficjalnie',
  'beginner.s6.title': 'Typowe błędy początkujących',
  'beginner.s6.p1': 'Pośpiech w decyzjach, pomijanie szczegółów wysyłki i ignorowanie podstaw bezpieczeństwa to typowe błędy nowych użytkowników.',
  'beginner.s6.p2': 'Zwolnienie tempa, weryfikacja informacji i korzystanie z oficjalnych kanałów pomagają uniknąć większości problemów.',
  'beginner.s7.title': 'Bezpieczeństwo dla początkujących',
  'beginner.s7.p1': 'Używaj silnych haseł, płać tylko przez oficjalne kanały i bądź ostrożny wobec nieznanych linków lub ofert.',
  'beginner.s7.p2': 'Ten niezależny zasób jest darmowy i nie prosi o dane osobowe.',
  'beginner.conclusion.title': 'Podsumowanie',
  'beginner.conclusion.p1': 'Start z USFans jest prosty, gdy rozumiesz podstawy i działasz krok po kroku.',
  'beginner.conclusion.p2': 'Korzystaj z przewodników, przeglądaj kategorie i zawsze weryfikuj ważne szczegóły samodzielnie.',
  'beginner.cta': 'Poznaj pełny sklep',
  'beginner.backHome': 'Wróć na stronę główną',
};